import React, { useState } from "react";
import Stepper from "../../components/Stepper/Stepper";
import {
  Step,
  StepperClasses,
  StepperColors,
} from "../../components/Stepper/StepperTypes";
import { Step1 } from "./Step1";
import HotelInfoHeader from "./HotelInfoHeader";
import Step2 from "./Step2";
import { ISelectedArrangements } from "components/StayCardPricesTable/StayCardPricesTable";
import Step3 from "./Step3";
import Step4 from "./Step4";


const Index: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedArrangements, setSelectedArrangements] =
    useState<ISelectedArrangements>({});
  const [selectedRooms, setSelectedRooms] = useState<{
    [roomIndex: number]: number;
  }>({});

  const handleStepChange = (step: number) => {
    if (step >= 0 && step < steps.length) {
      setIsLoading(true);
      setTimeout(() => {
        setCurrentStep(step);
        setIsLoading(false);
      }, 100);
    }
  };

  const steps: Step[] = [
    {
      label: "Dates",
      component: (
        <Step1 handleStepChange={() => handleStepChange(currentStep + 1)} />
      ),
    },
    {
      label: "Chambres",
      component: (
        <Step2
          selectedArrangements={selectedArrangements}
          setSelectedArrangements={setSelectedArrangements}
          selectedRooms={selectedRooms}
          setSelectedRooms={setSelectedRooms}
          handleStepChange={() => handleStepChange(currentStep + 1)}
        />
      ),
    },
    {
      label: "Récapitulatif",
      component: (
        <Step3
          selectedArrangements={selectedArrangements}
          selectedRooms={selectedRooms}
          handleStepChange={() => handleStepChange(currentStep + 1)}
        />
      ),
    },
    {
      label: "Détails et paiement",
      component: (
        <Step4  />
      ),
    },
  ];

  // Example custom colors and classes
  const customColors: StepperColors = {
    activeStepBg: "#222",
    activeStepHoverBg: "#1f2937",
    activeStepText: "#222",
    completedStepBg: "#22c55e",
    inactiveStepBg: "#d1d5db",
    connectorBg: "#222",
    buttonBg: "#aa8453",
    buttonHoverBg: "#222",
    spinnerBorder: "#aa8453",
  };

  const customClasses: StepperClasses = {
    stepCircle:
      "w-8 h-8 rounded-full flex items-center justify-center text-white font-bold",
    connectorLine: `h-[0.15rem] bg-[#222] absolute top-4`,
    stepLabel: "mt-6 text-sm font-medium",
    contentContainer: "p-4 bg-gray-100 shadow-md",
    previousButton: "px-4 py-2 disabled:opacity-50 transition",
    nextButton: "px-4 py-2 disabled:opacity-50 transition",
    spinner: "animate-spin rounded-full h-12 w-12 border-t-4",
  };

  return (
    <div className="min-h-screen bg-white">
      <Stepper
        steps={steps}
        headerComponent={<HotelInfoHeader handleStepChange={handleStepChange}/>}
        currentStep={currentStep}
        isLoading={isLoading}
        onStepChange={handleStepChange}
        colors={customColors}
        classes={customClasses}
      />
    </div>
  );
};

export default Index;
